import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../../shared/components/footer/footer.component';

@Component({
  selector: 'app-home-layout',
  standalone: true,
  imports: [RouterOutlet, FooterComponent],
  template: `
    <div class="home-layout">
      <!-- Main content -->
      <router-outlet></router-outlet>
      
      <!-- Genel footer -->
      <app-footer></app-footer>
    </div>
  `,
  styles: [`
    .home-layout {
      display: flex;
      flex-direction: column;
      min-height: 100vh;
    }
  `]
})
export class HomeLayoutComponent {} 